import PropTypes from 'prop-types';
import { buttonSkinData, buttonBtnTypeData, buttonSizeData, buttonTypeData } from '~button';
var callToAction = PropTypes.shape({
  type: PropTypes.oneOf(buttonTypeData),
  onClick: PropTypes.func,
  label: PropTypes.node,
  path: PropTypes.string,
  skin: PropTypes.oneOf(buttonSkinData),
  btnType: PropTypes.oneOf(buttonBtnTypeData),
  size: PropTypes.oneOf(buttonSizeData),
  icon: PropTypes.string
});
var callToActions = PropTypes.arrayOf(callToAction);
export default {
  callToAction: callToAction,
  callToActions: callToActions
};